module.exports = __webpack_public_path__ + "img/information-icon-gray.2c633e3c.svg";